/* eslint-disable camelcase */
import '@/styles/globals.css';
import '@/widgets/navLinks/nav-links.css';
import '@/styles/footer.css';
import '@/styles/search.css';
import '@/styles/globals-tw.css';
import ErrorBoundary from './error';

export default function App({ Component, pageProps }) {
  return (
    <ErrorBoundary>
      <Component {...pageProps} />
    </ErrorBoundary>
  );
}
